<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content" >
            <h2 data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">We Appreciate Your Patience</h2>
            <ul data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Coming Soon</li>
            </ul>
        </div>
    </div>
    
</div>
<!-- Start Coming Soon Area -->
<section class="coming-soon-area">
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-lg-6 col-md-12 col-sm-12 p-0">
                <div class="coming-soon-time">
                    <img src="assets/img/coming-soon-banner.png" alt="image">

                    <!-- <div id="timer">
                        <div id="days">{{days}} <span>Days</span></div>
                        <div id="hours">{{hours}} <span>Hours</span></div>
                        <div id="minutes">{{minutes}} <span>Minutes</span></div>
                        <div id="seconds">{{seconds}} <span>Seconds</span></div>
                    </div>

                    <div class="bg-shape1"><img src="assets/img/shape/4.svg" alt="image"></div>
                    <div class="bg-shape2"><img src="assets/img/shape/4.svg" alt="image"></div> -->
                </div>
            </div>

            <div class="col-lg-6 col-md-12 col-sm-12 p-0">
                <div class="coming-soon-content">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <!-- <div class="logo">
                                <a routerLink="/">
                                    <img src="assets/img/black-logo.png" alt="logo">
                                </a>
                            </div> -->

                            <h3>"Coming Soon: <br>Stay tuned for updates!"<br> follow us</h3>

                            <form>
                                <!-- <div class="form-group " >
                                    <input type="text" class="form-control" name="name" id="name" placeholder="Your Name">
                                </div>

                                <div class="form-group ">
                                    <input type="email" class="form-control" name="email" id="email" placeholder="Your Email Address">
                                </div> -->

                                <button type="submit" class="btns btn-primarys" routerLink="/">Back To Home</button>

                                <!-- <p>And don’t worry, we hate spam too! You can unsubcribe at anytime.</p> -->
                            </form>

                            <!-- <div class="social">
                                <ul>
                                    <li><a href="#" target="_blank" class="twitter"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#" target="_blank" class="youtube"><i class="fab fa-youtube"></i></a></li>
                                    <li><a href="#" target="_blank" class="facebook"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#" target="_blank" class="linkedin"><i class="fab fa-linkedin-in"></i></a></li>
                                    <li><a href="#" target="_blank" class="instagram"><i class="fab fa-instagram"></i></a></li>
                                </ul>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Coming Soon Area -->
